/** Optional URL segment between locale and school slug, e.g. `2025-2026`. */
const SCHOOLYEAR_RANGE_SEGMENT = /^\d{4}-\d{4}$/;

export function isSchoolyearSegment(segment: string): boolean {
  return SCHOOLYEAR_RANGE_SEGMENT.test(segment);
}

/**
 * Rebuilds `pathname` for routes shaped as `/:locale/:schoolyear?/:school/...`.
 * Ported from portal's `util.helpers/utils.schoolyear-path`.
 */
export function pathnameWithSchoolyear(opts: {
  pathname: string;
  locale: string;
  school: string;
  schoolyear: string | undefined;
}): string {
  const { pathname, locale, school, schoolyear } = opts;
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0 || parts[0] !== locale) {
    return pathname;
  }

  const second = parts[1];
  const third = parts[2];
  let rest: string[];

  if (second === school) {
    rest = parts.slice(2);
  } else if (third === school && second !== undefined && SCHOOLYEAR_RANGE_SEGMENT.test(second)) {
    rest = parts.slice(3);
  } else {
    const schoolIdx = parts.indexOf(school);
    if (schoolIdx === -1) {
      return pathname;
    }
    rest = parts.slice(schoolIdx + 1);
  }

  const head =
    schoolyear !== undefined && schoolyear !== "" ? [locale, schoolyear, school] : [locale, school];

  return `/${[...head, ...rest].join("/")}`;
}

export function schooljaarRangeFromAdminModel(sj: { fromYear: number; toYear: number }): string {
  return `${sj.fromYear}-${sj.toYear}`;
}
